import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zeroBefore'
})
export class ZeroBeforePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if(value == undefined){
      value = 0;
    }
    return ('0' + value).substr(-2);
  }

}
